import { default as styled } from 'styled-components';

import { fontTextXsRegular } from '@/styles/helpers';

export const Badge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

export const BadgeText = styled.p`
  ${fontTextXsRegular};
  color: ${(p) => p.theme.colors.oxfordBlue[100]};
`;

export const BadgeLogoWrapper = styled.div`
  & > svg {
    display: block;
    width: 120px;
    height: 10px;
  }
`;
